
export type PostApiV1RefundsRequestBody = {
  /** 환불할 주문 ID */
  orderId: string;
  /**
   * 환불 사유
   * @maxLength 500
   */
  reason: string;
};
